module.exports = __webpack_public_path__ + "img/cloud-2.32465498.png";